let LABELS = {
  n: gettext("Neutral"),
  s: gettext("Sell"),
  ss: gettext("Strong Sell"),
  b: gettext("Buy"),
  sb: gettext("Strong Buy"),
}

let CLASSES = {
  n: "",
  s: "negative",
  ss: "negative",
  b: "positive",
  sb: "positive",
}

angular.module('webtrader').component('technicalSignals', {
  templateUrl: BASE_URL+'templates/component.technicalSignals.html',
  controller: function ($http, $interval, Account) {
    this.data = {}
    // get option_status
    this.option_status = Account.info.option_status
    
    this.refresh = () => {
      $http.get('/api/technical_summary/').then((res) => {
        for (let item of res.data) {
          let result = this.data[item.instrument] = this.data[item.instrument] || {}
          this.data[item.instrument].cost = item.cost
          this.data[item.instrument][item.time] = this.data[item.instrument][item.time] || {}
          this.data[item.instrument][item.time][item.type] = {
            slug: item.summary,
            display: LABELS[item.summary],
            class: CLASSES[item.summary],
          }
        }
      })
    }

    this.refresh()
    $interval(() => {
      if (this.show)
        this.refresh()
    }, 61000)
  }
})
